// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"289":"ffaf77e1","551":"867e89b1"}[chunkId] + ".chunk.css";
};